/* Gold & Richie — predictive search
   Enhances a working search form. Without JS the form still submits. */

(function () {
  'use strict';

  var GR = window.GR;
  if (!GR) return;

  var input = document.querySelector('[data-gr-predictive-input]');
  if (!input) return;

  var results = document.querySelector('[data-gr-predictive-results]');
  var fallback = document.querySelector('[data-gr-search-default]');
  var clearBtn = document.querySelector('[data-gr-search-clear]');
  var controller = null;
  var timer = null;

  function setBusy(busy) {
    if (results) results.dataset.loading = busy ? 'true' : 'false';
  }

  function reset() {
    if (results) results.innerHTML = '';
    if (fallback) fallback.hidden = false;
    input.setAttribute('aria-expanded', 'false');
    setBusy(false);
  }

  function render(html) {
    if (!results) return;
    results.innerHTML = html;
    if (fallback) fallback.hidden = true;
    input.setAttribute('aria-expanded', 'true');

    var count = results.querySelectorAll('[role="option"]').length;
    GR.announce(count ? count + ' results' : 'No results');
  }

  function search(term) {
    if (controller) controller.abort();
    controller = new AbortController();

    var types = 'product';
    if (GR.predictiveCollections) types += ',collection';

    var url = GR.routes.predictiveSearch +
      '?q=' + encodeURIComponent(term) +
      '&resources[type]=' + types +
      '&resources[limit]=6' +
      '&section_id=predictive-search';

    setBusy(true);

    fetch(url, { signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Search failed');
        return response.text();
      })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var section = parsed.querySelector('.shopify-section');
        render(section ? section.innerHTML : text);
        setBusy(false);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        setBusy(false);
        reset();
      });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    if (clearBtn) clearBtn.hidden = term.length === 0;

    window.clearTimeout(timer);

    if (term.length < 2) {
      reset();
      return;
    }

    timer = window.setTimeout(function () { search(term); }, 240);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      reset();
      input.focus();
    });
  }

  // Arrow keys walk the suggestions; Escape returns to the field.
  input.addEventListener('keydown', function (event) {
    if (!results) return;
    var options = Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    if (!options.length) return;

    var current = options.indexOf(document.activeElement);

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      (options[current + 1] || options[0]).focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      (options[current - 1] || options[options.length - 1]).focus();
    }
  });

  results.addEventListener('keydown', function (event) {
    var options = Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    var current = options.indexOf(document.activeElement);

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      (options[current + 1] || input).focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (current <= 0) { input.focus(); } else { options[current - 1].focus(); }
    } else if (event.key === 'Escape') {
      input.focus();
    }
  });
})();
